import type { BeforeSendFn } from 'posthog-js';

// Raised by code we don't ship (extensions, in-app webviews, link-scanner bots); no stack to act on.
const THIRD_PARTY_NOISE = ['Script error.', 'Object Not Found Matching Id', 'ResizeObserver loop'];

export const dropThirdPartyExceptions: BeforeSendFn = event => {
  if (event.event !== '$exception') {
    return event;
  }

  const exceptions = (event.properties?.$exception_list ?? []) as { value?: unknown }[];
  const isNoise = exceptions.some(
    ({ value }) =>
      typeof value === 'string' && THIRD_PARTY_NOISE.some(noise => value.includes(noise)),
  );

  return isNoise ? null : event;
};
